module.exports = __webpack_public_path__ + "static/media/verification_rule-01.a4b48ce2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/verification_rule-01.png
// module id = 519
// module chunks = 0